import{gql as e}from"@apollo/client";const r=e`
  fragment projectSettingsFragment on ProjectSettingsGraphType {
    accessTokenExpiry
    hasHyperlinksInPost
    hasModuleProgression
    hasScheduler
    hasReducedUserPermissionAvailable
    impersonateUserLink
    refreshTokenExpiry
    hasGroupRequest
  }
`;export{r as PROJECT_SETTINGS_FRAGMENT};
//# sourceMappingURL=projectSettings.fragment.js.map
